import { Center, Loader, Stack, Text } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { useLeadsSheetStore } from "../../../../../../stores/LeadsStore";
import { findProspect } from "../../../../../../api/PRMAPI";
import AnswersGroupMobile from "./AnswersGroupMobile";

const TabAnswersMobile = ({ items }) => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const currentContainer = useLeadsSheetStore((s) => s.currentContainer);
  const [prospect, setProspect] = useState(current);
  const [loading, setLoading] = useState(false);

  const about = useMemo(() => {
    const aboutList = [
      { key: "%last_name%", value: "lastName" },
      { key: "%first_name%", value: "firstName" },
      { key: "%job_title%", value: "jobTitle" },
      { key: "%company%", value: "company" },
      { key: "%email%", value: "email" },
    ];
    let result = {};
    aboutList.forEach((item) => {
      result[item.value] =
        current?.properties?.find((x) => x.identifier_placeholder === item.key)
          ?.value || " - ";
    });

    return result;
  }, [current]);

  useEffect(() => {
    if (current?.id !== prospect?.id) setLoading(true);
  }, [current?.id, prospect?.id]);

  useEffect(() => {
    if (loading) {
      findProspect(current.id)
        .then((response) => {
          setProspect(response.data.contact_profile);
          setCurrent({
            ...current,
            history: response.data.contact_profile.history,
          });
        })
        .finally(() => setLoading(false));
    }
  }, [current.id, loading]);

  return (
    <>
      {loading ? (
        <Center h={"calc(100% - 103px)"}>
          <Loader type="oval" size={48} />
        </Center>
      ) : items.length > 0 ? (
        <Stack h={"100%"} mx={-14}>
          {items.map((item, index) => (
            <AnswersGroupMobile
              groupIndex={index}
              key={index}
              about={about}
              campaign={item}
              currentContainer={currentContainer}
              prospect={prospect}
              setLoading={setLoading}
              setProspect={setProspect}
            />
          ))}
        </Stack>
      ) : (
        <Text c={"dimmed"} mt={"xs"}>
          {lang.statistics.responses_viewer.no_answers}
        </Text>
      )}
    </>
  );
};

export default TabAnswersMobile;
